module.exports = __webpack_public_path__ + "img/vehicle-solutions-logo-type2-1.d88a9944.png";